import { makeAutoObservable } from 'mobx';

export class PaymentConfirmationStore {
  active = false;
  navigationPending = false;

  constructor() {
    makeAutoObservable(this);
  }

  start(): void {
    this.active = true;
    this.navigationPending = false;
  }

  startNavigation(): void {
    this.active = true;
    this.navigationPending = true;
  }

  stop(): void {
    this.active = false;
    this.navigationPending = false;
  }

  stopUnlessNavigating(): void {
    if (!this.navigationPending) {
      this.stop();
    }
  }

  finishNavigationAttempt(): void {
    if (this.navigationPending) {
      this.stop();
    }
  }
}

export const paymentConfirmationStore = new PaymentConfirmationStore();
